"use client"
import type React from "react"
import { motion } from "framer-motion"

const slideUp = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
}

export const YouTubeVideo: React.FC<{
  videoId: string
  title?: string
}> = ({ videoId, title }) => (
  <motion.div variants={slideUp} className="aspect-video w-full rounded-md overflow-hidden">
    <iframe
      width="100%"
      height="100%"
      src={`https://www.youtube.com/embed/${videoId}`}
      title={title || "YouTube video player"}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      className="w-full h-full"
    ></iframe>
  </motion.div>
)
